import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  h3 {
    font-weight: 400;
    font-size: 16px;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  height: 100%;

  .checkboxContainer {
    display: flex;
    gap: 16px;
    height: 100%;

    label {
      font-weight: 400;
      font-size: 14px;

      color: ${({ theme }) => theme.colors.gray[600]};

      white-space: nowrap;
      display: flex;
      gap: 8px;

      align-items: center;

      input[type='checkbox'] {
        display: none;
      }

      div {
        width: 18px;
        height: 18px;

        display: inline-block;
        position: relative;

        border-radius: 4px;
        cursor: pointer;
        border: 1.5px solid ${({ theme }) => theme.colors.orange.primary};
        padding: 2px;

        &::after {
          content: '';
          width: 100%;
          height: 100%;
          display: block;
          background: ${({ theme }) => theme.colors.orange.primary};
          border-radius: 2px;

          transform: scale(0);
        }
      }

      input[type='checkbox']:checked + div::after {
        transform: scale(1);
      }
    }
  }
`;
